module.exports = __webpack_public_path__ + "8b54561e4e17b609ec611b3599f7000f.MP3";